export interface ComponentIconValue {
  url?: string;
  width?: string;
  height?: string;
}

export const resolveIconCssSize = (
  value: string | ComponentIconValue | null | undefined,
  defaults?: Pick<ComponentIconValue, "width" | "height">,
) => {
  if (!value) {
    return {
      url: "",
      width: defaults?.width,
      height: defaults?.height,
    };
  }

  if (typeof value === "string") {
    return {
      url: value,
      width: defaults?.width,
      height: defaults?.height,
    };
  }

  return {
    url: value.url || "",
    width: value.width || defaults?.width,
    height: value.height || defaults?.height,
  };
};
